import { gql } from 'apollo-boost';


export const GET_ENDS = gql`
    query getEnds($offsetDate: String, $limit: Int!) {
        ends(offsetDate: $offsetDate, limit: $limit) {
            count
            posts {
                uid
                date
                title
                description
                cover {
                    type
                    filename
                    url
                }
                media {
                    type
                    filename
                    url
                }
                end {
                    category
                    copyright
                }
            }
        }
    }
`;

export const GET_END = gql`
    query getEND($uid: String!) {
        end(uid: $uid) {
            post {
                uid
                type
                date
                title
                description
                year
                media {
                    type
                    url
                }
                end {
                    category
                    copyright
                }
            }
            nextUid
        }
    }
`;
